import { cn } from '@/lib/shadcn/utils';
import { splitNoteLinks } from '@/modules/notes/noteLinks';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

const linkClassName =
  'text-primary-700 font-medium underline-offset-2 hover:underline';

interface NoteLinkProps {
  href: string;
  children: string;
}

export const NoteLink = ({ href, children }: NoteLinkProps) => (
  <a
    className={linkClassName}
    href={href}
    rel="noopener noreferrer"
    target="_blank"
  >
    {children}
  </a>
);

interface NoteTextProps {
  text: string;
  className?: string;
}

/** Note content as written, with URLs turned into links. */
export const NoteText = ({ text, className }: NoteTextProps) => (
  <Paragraph
    variant="body"
    className={cn('break-words whitespace-pre-wrap', className)}
  >
    {splitNoteLinks(text).map((part, index) =>
      part.kind === 'link' ? (
        <NoteLink key={index} href={part.href}>
          {part.text}
        </NoteLink>
      ) : (
        part.text
      ),
    )}
  </Paragraph>
);
